import { isNil } from "lodash";
import { Currency } from "./currency";
import { LoadingSite } from "./loading_site";
import { Role } from "./role";

export class User implements IUser {
    last_name: string;
    first_name: string;
    email: string;
    igg: string;
    
    is_admin?: boolean;
    workspace_admin?: boolean;

    roles: Array<Role> = [];
    workspaces: Array<Workspace> = [];

    id: number;
    connected_at?: string;
    workspace_connected_at?: string;

    canAccessAdminMenu(): boolean {
        let res = false;
        this.roles.forEach((r: Role) => {
            const adminPermissions = r.permissions.administration;
            res ||= (adminPermissions?.currencies?.edit && adminPermissions?.workspaces?.edit && adminPermissions?.users?.edit &&
            adminPermissions?.loading_sites?.edit && adminPermissions?.indexes?.edit && adminPermissions?.packagings?.edit && adminPermissions?.sales_organisations?.edit
            );
        });
    
        return res;
    }

    public constructor(d: User) {
        if (!isNil(d) && !isNil(d.id)) {
            this.id = d.id;
            this.last_name =  d.last_name;
            this.first_name = d.first_name;
            this.igg = d.igg;
            this.email = d.email;
            this.is_admin = d.is_admin;
            this.workspace_admin = d.workspace_admin;
            this.connected_at = d?.connected_at;
            this.workspace_connected_at = d?.workspace_connected_at;

            if (d.roles && d.roles.length > 0) {
                d.roles.forEach(r => this.roles.push(new Role(r)));
            }
            if (d.workspaces && d.workspaces.length > 0) {
                d.workspaces.forEach(g => this.workspaces.push(new Workspace(g)));
            }
        }
    }
}

export interface IUser {
    last_name: string;
    first_name: string;
    email: string;
    igg: string;
    roles: Array<Role>;
    workspaces: Array<Workspace>;
    id: number;
    is_admin?: boolean;
    workspace_admin?: boolean;
    workspace_connected_at?: string;
    connected_at?: string;
    canAccessAdminMenu(): boolean;

}

export class ShortUser implements IShortUser {
    last_name: string;
    first_name: string;
    email: string;
    igg: string;
    
    public constructor(d: ShortUser) {
        this.last_name = d.last_name;
        this.first_name = d.first_name;
        this.igg = d.igg;
        this.email = d.email;
    }
}

export interface IShortUser {
    last_name: string;
    first_name: string;
    email: string;
    igg: string;
}

export class Workspace implements IWorkspace {
    id: number;
    label: string;

    users?: Array<User> = [];
    pivot?: WorkspacePivot;
    role?: Role;

    public constructor(d: Workspace) {
        this.id = d.id;
        this.label = d.label;

        this.pivot = new WorkspacePivot(d.pivot);
        this.role = !isNil(d.role) ? new Role(d.role) : null;

        if (d.users && d.users?.length > 0) {
            d.users.forEach((user: User) => {
                this.users.push(new User(user));
            });
        }
    }
}

export interface IWorkspace {
    id: number;
    label: string;

    users?: Array<User>;
    pivot?: WorkspacePivot;
    role?: Role;
    
}

export interface IWorkspacePivot {
    is_admin: boolean;
    connected_at?: string;
}

export class WorkspacePivot implements IWorkspacePivot {
    is_admin: boolean;
    connected_at?: string;
    public constructor(d: WorkspacePivot) {
        this.is_admin = d?.is_admin;
        this.connected_at = d?.connected_at;
    }
}